const styles = (theme) => ({
    dialog: {
      width: 470,
      backgroundColor: theme.ModalBGColor,
    },
    dialogTitle: {
      color: theme.HeaderSelectedText,
      fontSize: theme.headerTextFontSize,
      fontWeight: 600,
    },
    divider: {
      borderBottom: `1px solid ${theme.gridIconBorderColor}`,
    },
    dialogFooter: {
      display: "flex",
      justifyContent: "space-between",
      padding: 16,
    },
    deliveryBillsHeaderText: {
      color: theme.TextColor,
    },
    dialogWrapper: {},
  });
    
    export default styles;